const activateTab = (root, mode) => {
    root.querySelectorAll('[data-home-filter-tab]').forEach((tab) => {
        const active = tab.dataset.homeFilterTab === mode
        tab.classList.toggle('is-active', active)
        tab.setAttribute('aria-selected', active ? 'true' : 'false')
    })

    root.querySelectorAll('[data-home-filter-panel]').forEach((panel) => {
        const active = panel.dataset.homeFilterPanel === mode
        panel.classList.toggle('is-active', active)
        panel.hidden = !active
    })
}

const initHomeFilterTabsRoot = (root) => {
    if (!root || root.dataset.initialized === 'true') {
        return
    }

    root.dataset.initialized = 'true'
    root.querySelectorAll('[data-home-filter-tab]').forEach((tab) => {
        tab.addEventListener('click', () => activateTab(root, tab.dataset.homeFilterTab))
    })
}

export const initHomeFilterTabs = () => {
    document.querySelectorAll('[data-home-filter-tabs]').forEach(initHomeFilterTabsRoot)
}
